module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-drenthe.svg?dc2d387ee0637f7e904bde4d1feac166";